import { customElement, GenesisElement, html, observable } from '@genesislcap/web-core';
import { Connect } from '@genesislcap/foundation-comms';
import { getUser } from '@genesislcap/foundation-auth';

@customElement({
  name: 'account-details',
  template: html<AccountDetails>`
    <rapid-divider></rapid-divider>
    <rapid-label :style=${(x) => x.labelStyle}>${(x) => x.counterpartyId}</rapid-label>
  `,
})
export class AccountDetails extends GenesisElement {

  @Connect connect!: Connect;

  @observable counterpartyId: string = '';

  get labelStyle() {
    const length = (this.counterpartyId ? this.counterpartyId.length : 0) + 5;
    const min = 16; // minimum width in ch
    const max = 80; // maximum width in ch to avoid overflow
    const ch = Math.min(Math.max(length, min), max);
    return `display:block; padding: 6px 12px; width: ${ch}ch;`;
  }

  async connectedCallback() {
    super.connectedCallback();
    try {
      const userName = getUser().userName;
      const response = await this.connect.request('USER_ATTRIBUTES', {
        REQUEST: {
          USER_NAME: userName,
        },
      });
      const reply = response && (response.REPLY as Array<Record<string, unknown>>);
      this.counterpartyId = reply && reply.length > 0 && (reply[0].COUNTERPARTY_ID as string) ? (reply[0].COUNTERPARTY_ID as string) : '';

    } catch (e) {
      // Fail silently in UI; optionally log
      // eslint-disable-next-line no-console
      console.warn('Failed to load USER_ATTRIBUTES', e);
    }
  }
}


